import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/assets/images/svg/chevron.svg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/global/news/[...page]/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["RenderBuilderContent"] */ "/opt/atlassian/pipelines/agent/build/src/components/builder.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogSchemaMarkup"] */ "/opt/atlassian/pipelines/agent/build/src/components/Common/SchemaMarkup.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/components/News/Navigation/Navigation.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/components/News/NewsCard/NewsCard.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/components/News/PublishDate/PublishDate.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/components/News/RelatedArticles/RelatedArticles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/components/News/Tags/Tags.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/components/ShareButton/ShareButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/components/UI/Navs/Breadcrumbs/Breadcrumbs.tsx");
